import React from 'react';
import styles from './calendarTooltipCard.module.styl';
import {bool, number, shape, string} from 'prop-types';
import {getShortTime, toDateStringLocale} from 'utils';
import cx from 'classnames';
import {percentageLevels} from 'utils/indicator/indicatorSettings';
import {Link} from 'react-router-dom';

export default function CalendarTooltipCard({trainingData, date, showCameraDetectionData}){

    let indicatorStyles = percentageLevels
        .indicatorColorWithOverload(trainingData.loadingPercent ?? 0);

    return (
        <div className={cx(styles.tooltipContainer, indicatorStyles.style)} data-test-name="pop_up_trainings" >
            <div className={styles.tooltipHeader}>Тренировка</div>
            <div className={styles.tooltipSubHeader}>
                <div>Загрузка места</div>
                <div className={cx(styles.tooltipValue, indicatorStyles.textStyle)}>{trainingData.loadingPercent}%</div>
            </div>
            <div className={styles.tooltipRow}>
                <div>Время</div>
                <div>{getShortTime(trainingData.startTime)} - {getShortTime(trainingData.endTime)} | {toDateStringLocale(date)}</div>
            </div>
            <div className={styles.tooltipRow}>
                <div>Организация</div>
                <div><Link to={`/school-summary/${trainingData.schoolId}`} className={styles.tooltipSchoolName} data-test-name="lnk_dashboard_school">{trainingData.schoolName}</Link></div>
            </div>
            <div className={styles.tooltipRow}>
                <div>Группа</div>
                <div>{trainingData.groupCode}</div>
            </div>
            <div className={styles.tooltipRow}>
                <div>Вид спорта</div>
                <div>{trainingData.sportTypeName}</div>
            </div>
            <div className={styles.tooltipRow}>
                <div>Этап спортивной подготовки</div>
                <div>{trainingData.sportTrainingLevel}</div>
            </div>
            <div className={styles.tooltipRow}>
                <div>Количество спортсменов</div>
                <div>{trainingData.participantsCount}/{trainingData.sportsmanCount}</div>
            </div>
            {showCameraDetectionData && trainingData.sportsmenCountByCamera !== null &&
                <div className={styles.tooltipRow}>
                    <div>Определено спортсменов</div>
                    <div>{trainingData.sportsmenCountByCamera}/{trainingData.sportsmanCount}</div>
                </div>
            }
            <div className={styles.tooltipRow}>
                <div>Тренер</div>
                <div>{trainingData.coachName}</div>
            </div>
        </div>
    );
}

CalendarTooltipCard.propTypes = {
    trainingData: shape({
        endTime: string,
        groupCode: string,
        loadingPercent: number,
        participantsCount: number,
        schoolName: string,
        sportTrainingLevel: string,
        sportTypeName: string,
        sportsmanCount: number,
        startTime: string,
        coachName: string,
        schoolId: number,
        sportsmenCountByCamera: number,
    }).isRequired,
    date: string.isRequired,
    showCameraDetectionData: bool.isRequired
}